import type { LoyaltyOfferForm } from '../components/LoyaltyDialog';
import { LoyaltyOfferType, LoyaltyType } from '../type';

const POS_LOYALTY_TYPES = [
  LoyaltyType.POS_AMOUNT,
  LoyaltyType.POS_PRODUCTS,
  LoyaltyType.POS_PRODUCTS_AMOUNT,
  LoyaltyType.POS_PASSAGE,
];

export const isPosLoyaltyType = (loyaltyType: LoyaltyType | null | undefined) =>
  !!loyaltyType && POS_LOYALTY_TYPES.includes(loyaltyType);

// A flat amount is taken off the selected products as a whole, so there is no single product to pick.
export const hasProductPriority = (offerType: LoyaltyOfferType | null) => offerType !== LoyaltyOfferType.FLAT;

type OfferTypeForm = Pick<
  LoyaltyOfferForm,
  'offerType' | 'offerValue' | 'loyaltyProducts' | 'loyaltyExtras' | 'productPriority'
>;

export const offerTypeFields = (form: OfferTypeForm, currencyCode: string) => {
  const products = { loyaltyProducts: form.loyaltyProducts || [], loyaltyExtras: form.loyaltyExtras || [] };
  switch (form.offerType) {
    case LoyaltyOfferType.FLAT:
      return { ...products, value: Number(form.offerValue), currency: currencyCode };
    case LoyaltyOfferType.PERCENTAGE:
      return { ...products, value: Number(form.offerValue), productPriority: form.productPriority };
    case LoyaltyOfferType.PRODUCT:
      return { ...products, productPriority: form.productPriority };
    default:
      throw new Error('Invalid offer type');
  }
};
